import { render, staticRenderFns } from "./NewsTable.vue?vue&type=template&id=e8a80aa0"
import script from "./NewsTable.vue?vue&type=script&lang=js"
export * from "./NewsTable.vue?vue&type=script&lang=js"
import style0 from "./NewsTable.vue?vue&type=style&index=0&id=e8a80aa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports